<!--系统管理-权限管理列表-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-card class="all-card-style " >

      <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline" >

          <a-form-item
            label="内容" class="ant-form-item2"
          >
            <a-input
              placeholder="请输入" v-model="queryInfo.keyword"
            >
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="button" @click="getUsers" >
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      列表表格-->
      <div>
        <a-button type="primary" html-type="submit" @click="toAddPage">
          添加
        </a-button>
        <a-table :pagination="pagination" :columns="columns" :data-source="data" >
          <span slot="action" slot-scope="text, record">
            <a @click="toEditPage(record)">修改</a>
            <a-divider type="vertical"/>
            <a @click="showDeleteModal(record)">删除</a>
          </span>
        </a-table>
      </div>
    </a-card>
    <!--              弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>


  </div>
</template>

<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'





  export default {
    name: 'propertyList',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1:"系统管理",
        titleMsg2:'权限管理',
        titleMsg3:'权限管理',
        data:[],
        role:{},
        columns:[
          {
            title: '编号',
            dataIndex: 'cRoleCode',
            key: 'cRoleCode',
          },
          {
            title: '角色名称',
            dataIndex: 'cRoleName',
            key: 'cRoleName',
          },
          {
            title: '角色权限',
            dataIndex: 'roleProperty',
            key: 'roleProperty',
          },
          {
            title: '创建时间',
            dataIndex: 'dCreateDate',
            key: 'dCreateDate',
          },

          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
          },

        ],
        deleteModalVisible:false,
        queryInfo:{

          keyword:"",
          page:1,
          limit:10,
          cEntID:''
        },
        pagination: {
          total: 0,
          pageSize: 10,//每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
        },
      }
    },
    mounted () {
      let that=this;
      that.queryInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.getUsers();
    },
    methods:{
      toAddPage(){
        this.$router.push({path:'/systemManagement/propertyManagement/propertyForm'});

      },
      showDeleteModal:function (record) {
        this.role=record;
        this.deleteModalVisible=true
      },

      toEditPage(record){
        let that=this;
        that.role=record;

        that.$router.push({name:'PropertyForm',params:{role:that.role}});
      },

      handleTableChange(pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
        this.queryInfo.page = pagination.current;
        this.queryInfo.limit = pagination.pageSize;
        this.getUsers();
      },
      async getUsers(){
        var _this=this
        _this.queryInfo.cSystemCode='节水灌溉';
        let res=await _this.$http.post('Role/PageList',_this.queryInfo)

        if(res.data.code ==200){
          _this.data=res.data.obj.list
          _this.pagination.total=res.data.obj.listTotal

        }
        else{

        }
      },

      async handleDelete(){
        let that=this;
        let param=null;
        let res=await that.$http.post('Role/Delete?ids='+that.role.ID,param)


        if(res.data.code=="200"){

          that.$message.success(res.data.message)
          that.getUsers();
        }
        else{
          that.$message.error(res.data.message)

        }
        this.deleteModalVisible=false;
      },
      handleOk:function () {
        // this.$router.push('/')
        this.deleteModalVisible=false
      },
    }
  }
</script>
